import { render, staticRenderFns } from "./simple-query-info.vue?vue&type=template&id=6a02a080"
import script from "./simple-query-info.vue?vue&type=script&lang=ts"
export * from "./simple-query-info.vue?vue&type=script&lang=ts"
import style0 from "./simple-query-info.vue?vue&type=style&index=0&id=6a02a080&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports